module.exports = __webpack_public_path__ + "708a54ff4ca0f94ae256a8eb2f7f655d.jpg";